var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/hand2"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.973 12.5.002-3.5c-.001-.926.67-1.678 1.5-1.679h.002c.831 0 1.505.752 1.505 1.679l.002 1m0 0v2.5m0-2.5c-.001-.926.67-1.678 1.5-1.679h.002c.831 0 1.505.752 1.505 1.679v1.179m0 1.321.002-1.321c-.001-.926.67-1.678 1.5-1.679h.002c.831 0 1.505.752 1.505 1.679V17a4 4 0 0 1-4 4H7.983s-5.138-7.287-5.62-7.92c-.723-.95-.42-2.023 1.39-2.023 1.809 0 2.852 2.953 4.23 2.953.008.002.009-3.775.002-10.331C7.984 2.753 8.656 2 9.486 2h.002c.83 0 1.504.752 1.504 1.679v7.642",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand2);
export default __webpack_public_path__ + "static/media/hand2.87d547c2288221e2e09470c71c5c1a47.svg";
export { ForwardRef as ReactComponent };